import { render, staticRenderFns } from "./Checkbox.vue?vue&type=template&id=3ed51d1e"
import script from "./Checkbox.vue?vue&type=script&lang=js"
export * from "./Checkbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ed51d1e')) {
      api.createRecord('3ed51d1e', component.options)
    } else {
      api.reload('3ed51d1e', component.options)
    }
    module.hot.accept("./Checkbox.vue?vue&type=template&id=3ed51d1e", function () {
      api.rerender('3ed51d1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/controls/Checkbox.vue"
export default component.exports